import { testSaga } from 'redux-saga-test-plan'
import { FAILED } from 'crom-api-constants'

import { LOGIN_REQUEST } from '../constants'
import { setLoading } from '../actions'

import { isFailedAction, logoutProcessCallSaga, failedRequestCallSaga } from '../saga'

describe('Authorization service sagas', () => {
    test('isFailedAction', () => {
        expect(isFailedAction({ type: `ACTION_${FAILED}` })).toBe(true)
        expect(isFailedAction({ type: 'ACTION' })).toBe(false)
    })

    describe('failedRequestCallSaga', () => {
        // eslint-disable-next-line jest/expect-expect
        test('with error code 401', () => {
            const action = {
                type: `COMMON_FAILED_ACTION_${FAILED}`,
                payload: { error: { code: 401 } },
            }

            testSaga(failedRequestCallSaga, action).next().call(logoutProcessCallSaga).next().returns(null)
        })
        // eslint-disable-next-line jest/expect-expect
        test('with error code 401 for LOGIN_REQUEST_FAILED action', () => {
            const action = {
                type: `${LOGIN_REQUEST}_${FAILED}`,
                payload: { error: { code: 401 } },
            }

            testSaga(failedRequestCallSaga, action).next().put(setLoading(false)).next().returns(null)
        })
        // eslint-disable-next-line jest/expect-expect
        test('with other error code', () => {
            const action = {
                type: `COMMON_FAILED_ACTION_${FAILED}`,
                payload: { error: { code: 404 } },
            }

            testSaga(failedRequestCallSaga, action).next().returns(null)
        })
    })
})
